// 主题注册表：新增主题 = tokens.css 加一个 :root[data-theme="..."] 块 + 这里加一条
export const THEMES = [
  { id: 'xuanye', label: '玄夜', desc: '深靛鎏金 · 暗色', metaColor: '#12172A', swatch: ['#12172A', '#C9A86A'] },
  { id: 'yabai', label: '雅白', desc: '纸墨鎏金 · 浅色', metaColor: '#F5F2EA', swatch: ['#F5F2EA', '#A07E3C'] },
  { id: 'classic', label: '经典', desc: '旧版紫白', metaColor: '#667EEA', swatch: ['#667EEA', '#FFFFFF'] },
];

export const DEFAULT_THEME = 'xuanye';
const STORAGE_KEY = 'destiny_theme';

export const getSavedTheme = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return THEMES.some((t) => t.id === saved) ? saved : DEFAULT_THEME;
  } catch (e) {
    return DEFAULT_THEME;
  }
};

// 应用主题：切 <html data-theme> + 持久化 + 同步浏览器 UI 色
export const applyTheme = (id) => {
  const theme = THEMES.find((t) => t.id === id) || THEMES[0];
  document.documentElement.dataset.theme = theme.id;
  try {
    localStorage.setItem(STORAGE_KEY, theme.id);
  } catch (e) { /* 隐私模式等场景忽略 */ }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme.metaColor);
};
